export default __webpack_public_path__ + "static/media/hht1_ep06_timeline_q05_a.ba05af34.png";